import { connectRouter, routerMiddleware } from 'connected-react-router'
import { applyMiddleware, combineReducers, createStore } from 'redux'
import thunk from 'redux-thunk'
import { composeWithDevTools } from 'redux-devtools-extension' 

import * as Account from './Account'
import * as Analytics from './Analytics'
import * as Auth from './Auth'
import * as Cards from './Cards'
import * as Channels from './Channels'
import * as Compare from './Compare'
import * as DCM from './DCM'
import * as Model from './Model'
import * as Explore from './Explore'
import * as Filter from './Filter'
import * as Forecast from './Forecast'
import * as FordForecast from './FordForecast'
import * as General from './General'
import * as Notify from './Notify'
import * as Optim from './Optim'
import * as Posts from './Posts'
import * as ResearchScenarios from './ResearchScenarios'
import * as Selections from './Selections'
import * as Selection from './Selection'
import * as Stories from './Stories'
import * as Study from './Study'

export default function configureStore(history: any, initialState: any) {
    const reducers = combineReducers({
        account: Account.reducer,
        auth: Auth.reducer,
        forecaster: combineReducers({
            fordForecast: FordForecast.reducer,
            forecast: Forecast.reducer,
            analytics: Analytics.reducer,
        }),
        cards: Cards.reducer,
        channels: Channels.reducer,
        compare: Compare.reducer,
        model: Model.reducer,
        explore: Explore.reducer,
        filter: Filter.reducer,
        general: General.reducer,
        notify: Notify.reducer,
        optimizer: Optim.reducer,
        posts: Posts.reducer,
        researchScenarios: ResearchScenarios.reducer,
        router: connectRouter(history),
        selection: Selection.reducer,
        selections: Selections.reducer, // deprecated
        stories: Stories.reducer,
        study: Study.reducer,
    })

    const middleware = [thunk, routerMiddleware(history)]

    // Use composeWithDevTools for enabling Redux DevTools in development
    const isDevelopment = process.env.NODE_ENV === 'development' || process.env.REACT_APP_ENABLE_REDUX_DEVTOOLS === 'true'
    const composeEnhancers = isDevelopment
        ? composeWithDevTools(applyMiddleware(...middleware)) // DevTools + middleware
        : applyMiddleware(...middleware) // Just middleware in production

    return createStore(reducers, initialState, composeEnhancers)
}
